import {
  AfterViewInit,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NbDialogRef } from "@nebular/theme";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { User } from "../../../@core/data/users";
import { UserService } from "../../../@core/services/user.service";
import { convertTimestamp } from "../../../@core/utils/convertTimestamps.service";
import { Receipt } from "../../../models/receipt.model";
import Shop from "../../../models/shop.model";

import { ReceiptService } from "../../../services/receipt.service";

@Component({
  selector: "ngx-layout-receipt-a4-stock-vfood",
  templateUrl: "layout-receipt-a4-stock-vfood.component.html",
  styleUrls: ["layout-receipt-a4-stock-vfood.component.scss"],
})
export class LayoutReceiptA4StockVFoodComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string;
  @Input() uid?: string;
  @Input() receipt?: Receipt;
  @Input() shop?: Shop;
  @Input() isRefLanguage?: boolean = false;

  loading = false;
  printing = false;
  displayName = "";

  constructor(
    private userService: UserService,
    private receiptService: ReceiptService
  ) {}

  ngOnInit() {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
          this.shopId = user.shopId ? user.shopId : user.uid;
          this.displayName = user.displayName ? user.displayName : user.email;
        } else {
          this.uid = "anonymous";
          this.shopId = "anonymous";
          this.displayName = "";
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit() {
    // setTimeout(() => {
    //   if (this.rePrint) {
    //     this.print();
    //   } else {
    //     this.printing = false;
    //   }
    // });
  }

  print() {
    this.printing = true;
  }
}
